export const SET_RECORD = 'SET_RECORD'
export const RESET_RECORD_INFO = 'RESET_RECORD_INFO'
export const RESET_CRITERIA_MODIFICATION = 'RESET_CRITERIA_MODIFICATION'
export const SET_MODIFICATIONS = 'SET_MODIFICATIONS'
export const SET_DIRECT_PARENT = 'SET_DIRECT_PARENT'
export const SET_ULTIMATE_PARENT = 'SET_ULTIMATE_PARENT'
export const SET_DIRECT_PARENT_RELATIONSHIP = 'SET_DIRECT_PARENT_RELATIONSHIP'
export const SET_ULTIMATE_PARENT_RELATIONSHIP = 'SET_ULTIMATE_PARENT_RELATIONSHIP'
export const SET_DIRECT_PARENT_REPORTING_EXCEPTION = 'SET_DIRECT_PARENT_REPORTING_EXCEPTION'
export const SET_ULTIMATE_PARENT_REPORTING_EXCEPTION = 'SET_ULTIMATE_PARENT_REPORTING_EXCEPTION'
export const SET_ULTIMATE_CHILDREN = 'SET_ULTIMATE_CHILDREN'
export const SET_DIRECT_CHILDREN = 'SET_DIRECT_CHILDREN'
export const SET_DIRECT_CHILD_RELATIONSHIPS = 'SET_DIRECT_CHILD_RELATIONSHIPS'
export const SET_ULTIMATE_CHILD_RELATIONSHIPS = 'SET_ULTIMATE_CHILD_RELATIONSHIPS'
export const SET_DIRECT_CHILD_RELATIONSHIPS_DATA = 'SET_DIRECT_CHILD_RELATIONSHIPS_DATA'
export const SET_ULTIMATE_CHILD_RELATIONSHIPS_DATA = 'SET_ULTIMATE_CHILD_RELATIONSHIPS_DATA'
export const SET_RA = 'SET_RA'
export const SET_OVA = 'SET_OVA'
export const SET_ENTITY_RA = 'SET_ENTITY_RA'
export const SET_ELF = 'SET_ELF'
export const SET_CRITERIA_MODIFICATION = 'SET_CRITERIA_MODIFICATION'
export const TOGGLE_RELATIONSHIP_MODAL = 'TOGGLE_RELATIONSHIP_MODAL'
export const TOGGLE_ISSUER_MODAL = 'TOGGLE_ISSUER_MODAL'
export const CHANGE_LOADING = 'CHANGE_LOADING'
export const CHANGE_MODIFICATION_TYPE = 'CHANGE_MODIFICATION_TYPE'
export const TOGGLE_DISPLAY_SECTION = 'TOGGLE_DISPLAY_SECTION'
export const ADD_LEI_ISSUER = 'ADD_LEI_ISSUER'
export const SET_SUCCESSOR_ENTITY = 'SET_SUCCESSOR_ENTITY'
export const SET_SUCCESSOR_ENTITIES = 'SET_SUCCESSOR_ENTITIES'
export const SET_ASSOCIATED_ENTITY = 'SET_ASSOCIATED_ENTITY'
export const SHOW_RECORD_EXCEPTION = 'SHOW_RECORD_EXCEPTION'
export const TOGGLE_FULL_DATA_MODAL = 'TOGGLE_FULL_DATA_MODAL'
export const TOGGLE_MODIFICATIONS_MODAL = 'TOGGLE_MODIFICATIONS_MODAL'
export const TOGGLE_CHANGES_MODAL = 'TOGGLE_CHANGES_MODAL'
export const SET_ISIN = 'SET_ISIN'
export const CLEAR_ISIN = 'CLEAR_ISIN'
export const SET_RECORD_MODIFICATIONS = 'SET_RECORD_MODIFICATIONS'
export const SET_RECORD_XML = 'SET_RECORD_XML'
export const SET_RR_XML = 'SET_RR_XML'
export const SET_REPEX_XML = 'SET_REPEX_XML'
export const SET_HEAD_OFFICE = 'SET_HEAD_OFFICE'
export const SET_BRANCHES = 'SET_BRANCHES'
export const SET_FUND_MANAGER = 'SET_FUND_MANAGER'
export const SET_MANAGED_FUNDS = 'SET_MANAGED_FUNDS'
export const SET_UMBRELLA_FUND = 'SET_UMBRELLA_FUND'
export const SET_SUB_FUNDS = 'SET_SUB_FUNDS'
export const SET_MASTER_FUND = 'SET_MASTER_FUND'
export const SET_FEEDER_FUNDS = 'SET_FEEDER_FUNDS'
export const SET_HEAD_OFFICE_RELATIONSHIP_DATA = 'SET_HEAD_OFFICE_RELATIONSHIP_DATA'
export const SET_BRANCH_RELATIONSHIPS_DATA = 'SET_BRANCH_RELATIONSHIPS_DATA'
export const SET_FUND_MANAGER_RELATIONSHIP_DATA = 'SET_FUND_MANAGER_RELATIONSHIP_DATA'
export const SET_MANAGED_FUND_RELATIONSHIPS_DATA = 'SET_MANAGED_FUND_RELATIONSHIPS_DATA'
export const SET_MASTER_FUND_RELATIONSHIP_DATA = 'SET_MASTER_FUND_RELATIONSHIP_DATA'
export const SET_FEEDER_FUND_RELATIONSHIPS_DATA = 'SET_FEEDER_FUND_RELATIONSHIPS_DATA'
export const SET_UMBRELLA_FUND_RELATIONSHIP_DATA = 'SET_UMBRELLA_FUND_RELATIONSHIP_DATA'
export const SET_SUB_FUND_RELATIONSHIPS_DATA = 'SET_SUB_FUND_RELATIONSHIPS_DATA'
export const SET_ADDRESS_DATA = 'SET_ADDRESS_DATA'



// WEBPACK FOOTER //
// ./src/store/modules/record/mutations-types.js